<template>
    <v-card elevation="0">
        <!--        <v-card-actions>
                    <v-card elevation="0" outlined width="100%">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" elevation="0" class="white&#45;&#45;text">Inport
                                <v-icon>mdi-arrow-bottom-left</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card-actions>-->
<!--        <configs-popup-edit-info ref="configs-popup-edit-info"></configs-popup-edit-info>-->
<!--        <c-edit-tag-popup ref="c-edit-tag-popup"></c-edit-tag-popup>-->
<!--        <c-p-r-deploy-with-merge-popup ref="c-p-r-deploy-with-merge-popup"></c-p-r-deploy-with-merge-popup>-->
        <v-card-actions class="ma-0 pa-0">
            <c-master-table
                    v-on:show-configs-popup-edit-info="showEditInfoPopup"
                    v-on:show-c-edit-tag-popup="showEditTagPopup"
                    v-on:show-c-p-r-deploy-with-merge-popup="showDeployWithMergePopup"
            >
            </c-master-table>
        </v-card-actions>
    </v-card>
</template>

<script>

import CEditTagPopup from "@/modules/mconfigs/views/pre-release/popups/c-edit-tag-popup";
import CPRDeployWithMergePopup from "@/modules/mconfigs/views/pre-release/popups/c-p-r-deploy-with-merge-popup";
import ConfigsPopupEditInfo from "@/modules/mconfigs/views/popups/configs-popup-edit-info";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import CMasterTable from "@/modules/mconfigs/views/master/c-master-table";

export default {
    name: "c-master",
    components: {CMasterTable, ConfigsPopupEditInfo, CPRDeployWithMergePopup, CEditTagPopup},
    methods:{
        showEditInfoPopup(config){
            // this.$refs['configs-popup-edit-info'].show(config, function (config, newInfo) {
            //     let copy = config.clone()
            //     copy.info = newInfo
            //     ConfigStoreUtils.updateReleaseConfig(copy, null)
            //         .then(() => {
            //             this.$notify({title: 'Info successfully changed!', text: "", type: "succes"});
            //         }).catch((error) => {
            //         this.$notify({title: 'Info change failed!', text: error, type: "error"});
            //     })
            // })
        },
        showDeployWithMergePopup(item){
            // this.$refs['c-p-r-deploy-with-merge-popup'].show(item)
        },
        showEditTagPopup(item){
            // this.$refs['c-edit-tag-popup'].show(item)
        },
    }
}
</script>

<style scoped>

</style>